<template>
  <el-container class="stui-content" style="display: block;">

    <template>
      <el-table
    	:data="list"
      height="1500"
    	border
    	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">

      <el-table-column

        width="180"
        label="功能"
         >
         <template slot-scope="scope">
             <div>{{scope.row.name}}</div>
         </template>
      </el-table-column>
    	<el-table-column
        width="180"
    	  label="lid"
    	   >
         <template slot-scope="scope">
             <div>{{scope.row.lid}}</div>
         </template>
    	</el-table-column>
    	<el-table-column
    	  width="100"
    	  label="排序"
    	   >
    	   <template slot-scope="scope">
    	       <div @click="paixu(scope.row.orders,scope.row.id)">{{scope.row.orders}}</div>
    	   </template>
    	</el-table-column>
      <el-table-column

        width="100"
        label="展示效果"
         >
         <template slot-scope="scope">
             <div  @click="changexiaoguo(scope.row.duowei,scope.row.id)">{{scope.row.duowei}}</div>
         </template>
      </el-table-column>


      </el-table>
    </template>
  <el-dialog
    title="修改多维"
    :visible.sync="imgVisiblecxiaoguo"
    width="30%"
    center>
    <el-select v-model="xiaoguoc"   multiple placeholder="请选择" >
        <el-option
          v-for="item in xiaoguoArr"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
    <span slot="footer" class="dialog-footer">
  	<el-button @click="imgVisiblecxiaoguo = false">取 消</el-button>
  	<el-button type="primary" @click="dochangexiaoguo()">确 定</el-button>
    </span>
  </el-dialog>
<el-dialog
      title="修改"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="changes"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="centerDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doChange()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>


</template>

<script>

  export default {
    data() {
       return {
        list: [],
        addT:'',
        lid:0,
        addP:0,
        imgVisiblecxiaoguo:false,
        xiaoguoArr:['无','通用多维','精准多维','投放多维','内部多维','标识多维','一般多维','地区多维','精细多维','点线多维','突发多维','指向元素','连接元素','飞行元素','环绕多维'],
        xiaoguoc:['无'],
        xiaoguoc_id:0,
        centerDialogVisible:false,
        changes:0,
        pai_id:0
      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData()

    },

	methods:{
    paixu(pai,id){
      this.pai_id = id
      this.changes = pai
      this.centerDialogVisible = true
    },
    doChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.pai_id,
          n:this.changes
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/sduoweichange'
      })
      .then(res=>{
         this.centerDialogVisible = false
         this.c_id = 0
         this.t = ''
         this.changes = ''
         this.loadData()

      })
      .catch(err=>{

      });
    },
    changexiaoguo(xiaoguo,id){
      this.xiaoguoc_id = id
      this.xiaoguoc = xiaoguo.split(',')
      this.imgVisiblecxiaoguo = true
    },
    dochangexiaoguo(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.xiaoguoc_id,
          xiaoguo:this.xiaoguoc.join(','),
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/sduoweixiaoguo'
      })
      .then(res=>{
        this.imgVisiblecxiaoguo = false
        this.xiaoguoc_id = 0
        this.xiaoguoc = ['无']
      	this.loadData()

      })
      .catch(err=>{

      });
    },

    loadData(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          week:this.value,
          s_id:this.qipaoId
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/sduoweiList'
      })
      .then(res=>{
      	this.list = res.data;

      })
      .catch(err=>{

      });
    },


    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .searchT{
  	width: 80%;
  	margin-left: 10%;
  	height: 30px;
  }
  .stui-content{
    margin-left: 10%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }


</style>



// WEBPACK FOOTER //
// src/components/main/sduowei.vue